import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Preloader from "../components/Preloader";
import PageTransition from "../components/PageTransition";
import Hero from "../components/Hero";
import AboutTeaser from "../components/AboutTeaser";
import Services from "../components/Services";
import ProductMarquee from "../components/ProductMarquee";
import ProductRail from "../components/ProductRail";
import Projects from "../components/Projects";
import WhyIntExt from "../components/WhyIntExt";
import Testimonials from "../components/Testimonials";
import Journal from "../components/Journal";
import Stats from "../components/Stats";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

let preloaded = false;

export default function Home() {
  const [loading, setLoading] = useState(!preloaded);
  const { hash } = useLocation();

  useEffect(() => {
    if (!loading) return;
    const t = setTimeout(() => {
      preloaded = true;
      setLoading(false);
    }, 1700);
    return () => clearTimeout(t);
  }, [loading]);

  useEffect(() => {
    if (loading || !hash) return;
    const t = setTimeout(() => {
      const el = document.querySelector(hash);
      if (!el) return;
      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70, immediate: true });
      else el.scrollIntoView();
    }, 250);
    return () => clearTimeout(t);
  }, [loading, hash]);

  return (
    <PageTransition>
      <main>
        <AnimatePresence>{loading && <Preloader />}</AnimatePresence>
        <Hero start={!loading} />
        <AboutTeaser />
        <Services />
        <ProductMarquee />
        <ProductRail />
        <Projects />
        <WhyIntExt />
        <Testimonials />
        <Journal />
        <Stats />
        <ContactSection />
        <Footer />
      </main>
    </PageTransition>
  );
}
